import './index.sass';

const Info = ({ info }) => <span className='label-info'>{` (${info})`}</span>;

export default Info;
